<template>
    <div class="card" style="border: none;">
        <data-form :data="data" :formFields="formFields" @save="saveData" @cancel="cancel" />
    </div>
    <hr />
    <form-futher class="text-end" :key="data['id'] + 'foother'" v-if="data" :createdBy="data['createdBy']"
        :created="data['createdAt']" :updatedBy="data['updatedBy']" :updated="data['updatedAt']" />
</template>

<script>
import DataForm from "../widgets/DataForm.vue";
import AuthorizedDataService from "../../services/authorized.service";
import FormFuther from "../users/FormFuther.vue";

export default {
    name: "authorized-form",
    props: ["data"],
    components: {
        DataForm,
        FormFuther,
    },
    data() {
        return { message: "" };
    },
    computed: {
        formFields() {
            return {
                id: { type: "hidden" },
                full_name: { label: "Ime i prezime", type: "text" },
                jmbg: { label: "JMBG", type: "text" },
                address: { label: "Adresa", type: "text" },
                lk_num: { label: "Broj lične karte", type: "text" },
            };
        },
    },
    methods: {
        saveData(newData) {
            if (!newData.full_name) {
                this.$store.commit("app/showAlert", {
                    type: "danger",
                    message: "Ime i prezime je obavezno!",
                });
                return;
            }
            if (!newData.address) {
                this.$store.commit("app/showAlert", {
                    type: "danger",
                    message: "Adresa je obavezna!",
                });
                return;
            }
            if (!newData.lk_num) {
                this.$store.commit("app/showAlert", {
                    type: "danger",
                    message: "Broj lične karte je obavezan!",
                });
                return;
            }
            if (!newData.jmbg) {
                this.$store.commit("app/showAlert", {
                    type: "danger",
                    message: "JMBG je obavezan!",
                });
                return;
            }
            if (newData.jmbg.length !== 13) {
                this.$store.commit("app/showAlert", {
                    type: "danger",
                    message: "JMBG mora imati 13 karaktera!",
                });
                return;
            }

            if (newData && newData.id) {
                this.updateAuthorized(newData);
            } else {
                this.createAuthorized(newData);
            }
        },
        cancel() {
            this.$store.commit("app/hideModal");
        },
        updateAuthorized(newData) {
            AuthorizedDataService.update(newData.id, newData)
                .then(() => {
                    this.$store.commit("app/showAlert", {
                        type: "success",
                        message: "Ovlašćenik je promenjen!",
                    });
                    this.$store.commit("app/hideModal");
                })
                .catch((e) => {
                    this.$store.commit("app/showAlert", {
                        type: "danger",
                        message: e,
                    });
                });
        },
        createAuthorized(newData) {
            AuthorizedDataService.create(newData)
                .then(() => {
                    this.$store.commit("app/showAlert", {
                        type: "success",
                        message: "Ovlašćenik je kreiran!",
                    });
                    this.$store.commit("app/hideModal");
                })
                .catch((e) => {
                    this.$store.commit("app/showAlert", {
                        type: "danger",
                        message: e,
                    });
                });
        },
    },
};
</script>
